import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useScreen } from '../../../../../hooks'
import { BuildingSelect } from '../../../../Building'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import {
  CONTRACT_FORM_BUILDING_OPTIONS_API_PARAMS,
  CONTRACT_FORM_FIELD_NAME_BUILDING,
  CONTRACT_FORM_FIELD_NAME_FLAT,
} from '../../../Contract.constants'

function BuildingField(props) {
  const { t } = useTranslation()

  const { setFieldValue } = useFormikContext()

  const { isMobileScreenSize } = useScreen()

  function handleResetFlat() {
    setFieldValue(CONTRACT_FORM_FIELD_NAME_FLAT, null)
  }

  return (
    <FormikField
      {...props}
      Component={FormFieldSelectNG}
      Select={BuildingSelect}
      apiParams={CONTRACT_FORM_BUILDING_OPTIONS_API_PARAMS}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Contract.BuildingPlaceholderKey'),
          },
        },
      }}
      emptyValue={null}
      fieldComponentProps={{
        label: `${t('Contract.BuildingLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={CONTRACT_FORM_FIELD_NAME_BUILDING}
      onChange={handleResetFlat}
      onClear={handleResetFlat}
    />
  )
}

export default BuildingField
